































import { Component, Vue, Watch } from "vue-property-decorator";
import { padHeadPanel2 } from "@/components";
import salezl from "./components/salezl.vue";
import salebb from "./components/salebb.vue";
import goodsbb from "./components/goodsbb.vue";
import vipbb from "./components/vipbb.vue";
import staffbb from "./components/staffbb.vue";
import deliverybb from "./components/deliverybb.vue";
import { TbShop } from "@/http";

@Component({
  components: {
    padHeadPanel2,
    salezl,
    salebb,
    goodsbb,
    vipbb,
    staffbb,
    deliverybb
  },
})
export default class report extends Vue {
  active = "xszl";
  userInfo: any = {};

  /**是否开通网店 */
  isOnline=false;

  start="";
  end="";
  curZL="";
  id="";
  orderStatus="";

  public $refs: {};
  created() {
    this.id = this.$route.query.id;
    this.orderStatus = this.$route.query.orderStatus;
    this.getOnlineAuth();
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
      this.start = this.$route.query.start;
		this.end = this.$route.query.end;
		this.curZL = this.$route.query.curZL;
  }
  mounted() {
    let allotactive = localStorage.getItem("allotactive")
        ? Number(localStorage.getItem("allotactive"))
        : 0;
        switch (allotactive) {
          case 0:
          this.active = 'xszl';
            break;
          case 1:
          this.active = 'xsbb';
            break;
          case 2:
          this.active = 'goodsbb';
            break;
          case 3:
          this.active = 'vipbb';
            break;
          case 4:
          this.active = 'ygbb';
            break;
          case 5:
          this.active = 'thbb';
            break;

          default:
            break;
        }

        localStorage.removeItem('allotactive');

    if (this.$route.query.tag ) {
      if(this.$route.query.tag == "goods"){
        this.active = "goodsbb";
      }else if(this.$route.query.tag == "order"){
				this.active = "xsbb";
			}else if(this.$route.query.tag == "vip"){
				this.active = "vipbb";
			}

    }
  }
  /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    /**判断是否开通网店 */
    async getOnlineAuth(){
        let res = await TbShop.GetOnlineIsOpen();
        if(res===true){
          this.isOnline = res;
        }else{
          this.isOnline = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/report.vue